import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader } from "./Loader";

// Requires a signed-in user. Guests/anon redirected to /login.
export function RequireAuth({ children, adminOnly = false }) {
  const { user, guest, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!user || guest) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (adminOnly && !user.is_admin) return <Navigate to="/" replace />;
  return children;
}
